import { PaymentStrip } from "@/ui/components/pdp/payment-strip";

export const PAYMENT_ICON_MAP: Record<string, { src: string; alt: string }> = {
	// visa/mastercard/apple-pay/google-pay/sepa/revolut-pay point at
	// public/payment/*.svg (Task 9): tight-bounding-box crops of the same marks,
	// not a recolor or a redraw. See public/payment/README.md for provenance.
	// The old public/payment-icons/*.webp versions stayed as 1024x1024 canvases
	// with the wordmark on a small fraction of it, so at the 20px row height
	// used everywhere below, the mark itself was only a few pixels tall.
	card: { src: "/payment/visa.svg", alt: "Visa" },
	visa: { src: "/payment/visa.svg", alt: "Visa" },
	mastercard: { src: "/payment/mastercard.svg", alt: "Mastercard" },
	"apple-pay": { src: "/payment/applepay.svg", alt: "Apple Pay" },
	"google-pay": { src: "/payment/googlepay.svg", alt: "Google Pay" },
	sepa: { src: "/payment/sepa.svg", alt: "SEPA" },
	// §10: the SEPA mark belongs to the Vorkasse tile and nowhere else in the
	// method list. The `sepa` key above stays only for the PDP/footer trust strip,
	// where it becomes honest for the first time once Vorkasse is live.
	// This entry is owned by Task 20 alone, no other task edits PAYMENT_ICON_MAP.
	vorkasse: { src: "/payment/sepa.svg", alt: "SEPA" },
	"revolut-pay": { src: "/payment/revolut.svg", alt: "Revolut" },
	"robinhood-connect": { src: "/payment-icons/robinhood-logo.webp", alt: "Robinhood" },
	banxa: { src: "/payment-icons/banxa.png", alt: "Banxa" },
	moonpay: { src: "/payment-icons/moonpay.svg", alt: "MoonPay" },
	// Versioned query bypasses a previously cached production 500 for this static asset.
	"coinbase-pay": { src: "/payment-icons/coinbase.png?v=20260710", alt: "Coinbase Pay" },
	binance: { src: "/payment-icons/binance.png", alt: "Binance Pay" },
	klarna: { src: "/payment-icons/klarna.webp", alt: "Klarna" },
};

interface PaymentIconsProps {
	label?: string;
	size?: "sm" | "md";
	className?: string;
	channel?: string;
	countryCode?: string;
}

/**
 * Compatibility wrapper: informational surfaces share one frameless brand list.
 * Informationsflächen laden die 48-px-WebP-Ableitungen statt der Raster-SVGs (193 KB).
 */
export function PaymentIcons({ label, size = "sm", className, channel, countryCode }: PaymentIconsProps) {
	return (
		<PaymentStrip
			channel={channel}
			countryCode={countryCode}
			label={label}
			compact={size === "sm"}
			assetVariant="compact"
			layout="grid"
			className={className}
		/>
	);
}
